export default {
  FE_001: 'Falha ao conectar com o backend.',
  FE_002: 'Parâmetros obrigatorios não foram informados corretamente.',
  FE_003: 'Usuário não elegível para adesão',
  FE_004: 'Código reenviado com sucesso',
  FE_005: 'Não foi possível enviar o código',
  FE_006: 'Não foi possível obter as bandeiras de cartão',
  FE_007: 'Vendedor não cadastrado',
  BE_001: 'Adesão não realizada',
  ED_001: 'Falha ao realizar tokenização do cartão',
};
